module.exports = __webpack_public_path__ + "static/media/menu-4.786a1911.png";